module.exports = __webpack_public_path__ + "static/media/6.20fe92dc.jpg";